export default __webpack_public_path__ + "static/content-l3-img-1-f6d9b691b5f21b1909d4bc38f2b7afe2.png";